const getColorFromVariant = (theme, variant) => {
  const { palette } = theme;

  switch (variant) {
    case 'primary':
      return palette.primary.main;
    case 'primary-light':
      return palette.primary.light;
    case 'primary-lighter':
      return palette.primary.lighter;
    case 'primary-lightest':
      return palette.primary.lightest;
    case 'primary-dark':
      return palette.primary.dark;
    case 'primary-darker':
      return palette.primary.darker;
    case 'neutral':
      return palette.text.primary;
    case 'neutral-faded':
    case 'secondary':
      return palette.text.disabled;
    case 'info':
      return palette.info.main;
    case 'positive':
    case 'success':
      return palette.success.dark;
    case 'warning':
      return palette.warning.main;
    case 'critical':
    case 'error':
      return palette.error.main;
    case 'disabled':
      return palette.text.disabled;
    case 'white':
      return 'white';
    case 'unavailability':
      return theme.palette.unavailability.color;
    case 'day':
      return palette.warning.main;
    case 'night':
      return 'blue';
    default:
      return theme.palette.primary.main;
  }
};

export default getColorFromVariant;
